export default "__VITE_ASSET__9bd67547__"